import React, { memo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Booking } from "../../../types";
import { setDangerouslyInnerHtml } from "../../../helpers/set-inner-html";

interface IStatusProps {
  status: string;
  waiting_rank?: number;
}

const StatusWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const StatusText = styled.div`
  color: white;
  padding: 20px 60px;
  border-radius: 4px;
  margin-bottom: 36px;

  &.success {
    background-color: ${(props) => props.theme.success};
  }

  &.info {
    color: ${(props) => props.theme.textColor};
    background-color: ${(props) => props.theme.success}40;
  }
`;

const Status = (props: IStatusProps) => {
  const { t } = useTranslation();

  let message = {};
  let statusColor = "success";

  switch (props.status) {
    case "validated":
      message = t("instabook.bookings.success.info");
      break;
    case "initialized":
      message = t("instabook.bookings.success.waiting_for_confirmation");
      break;
    case "waiting":
      message = (
        <span
          dangerouslySetInnerHTML={setDangerouslyInnerHtml(
            t,
            "instabook.bookings.success.waiting",
            {
              rank: props.waiting_rank,
            }
          )}
        />
      );
      break;
    case "waiting_payment":
      message = t(
        "instabook.bookings.success.waiting_for_payment_confirmation"
      );
      statusColor = "info";
      break;
    default:
      message = t("instabook.bookings.success.info");
  }

  return (
    <StatusWrapper data-test="reservation-status">
      <StatusText className={statusColor}>{message}</StatusText>
    </StatusWrapper>
  );
};

export const ReservationStatus = memo(Status);
